import { render, staticRenderFns } from "./ProductModelUpdate.vue?vue&type=template&id=5b36a433&"
import script from "./ProductModelUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductModelUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports